export var DaysOfWeek;
(function (DaysOfWeek) {
    DaysOfWeek["LUNES"] = "LUNES";
    DaysOfWeek["MARTES"] = "MARTES";
    DaysOfWeek["MIERCOLES"] = "MIERCOLES";
    DaysOfWeek["JUEVES"] = "JUEVES";
    DaysOfWeek["VIERNES"] = "VIERNES";
    DaysOfWeek["SABADO"] = "SABADO";
    DaysOfWeek["DOMINGO"] = "DOMINGO";
})(DaysOfWeek || (DaysOfWeek = {}));
export var DistanceRadius;
(function (DistanceRadius) {
    DistanceRadius["RADIUS1"] = "radius1";
    DistanceRadius["RADIUS2"] = "radius2";
    DistanceRadius["RADIUS3"] = "radius3";
    DistanceRadius["RADIUS4"] = "radius4";
})(DistanceRadius || (DistanceRadius = {}));
export class DeliveryMenu {
    constructor(id) {
        this.id = '';
        this.address = '';
        this.costShipping = undefined;
        this.active = false;
        this.descriptionDeliveryDefault = '';
        this.imageDelivery = '';
        this.imageDeliveryURL = '';
        this.location = undefined;
        this.menuId = '';
        this.onlinePayment = false;
        this.payment = undefined;
        this.phones = undefined;
        this.restaurantId = '';
        this.schedule = undefined;
        this.shipping = false;
        this.collect = false;
        this.descriptionDelivery = [];
        this.descriptionEstimates = [];
        this.id = id;
    }
}
